module.exports = __webpack_public_path__ + "images/feature/project-recap-b976decb3ef2a94b0554bb6b17c91b8e.png";